$(document).ready(function() {
	let inProductPage = window.location.pathname.includes('products') ? true : false;
	let defaultLocale = "zh-TW";
	let currentLocale = Shopify.locale;

	if (!inProductPage) return;

	$("button").on('click', function() {
		if (defaultLocale == currentLocale) return;

		let bookingPopup = document.querySelector('#bta-product-widget iframe');
		let dayPicker = bookingPopup.contentWindow.document.querySelector('.DayPicker');

		updateSlotText(bookingPopup);

		dayPicker.addEventListener('click', function() {
			updateSlotText(bookingPopup);
		})

		let widgetTitle = bookingPopup.contentWindow.document.querySelector('.widget-title');
		let widgetLocationLabel = bookingPopup.contentWindow.document.querySelector('.select-block .titles');
		let widgetLocationSelectTitle = bookingPopup.contentWindow.document.querySelector('.select-block div div div div');
		let widgetLanguageLabel = bookingPopup.contentWindow.document.querySelectorAll('.select-block label');
		let widgetLanguageOptions = bookingPopup.contentWindow.document.querySelectorAll('.select-block button');
		let widgetAddToCartBtn = bookingPopup.contentWindow.document.querySelector('.pure-button');

		widgetTitle.innerText = "Choose a class";
		widgetLocationLabel.innerText = "Location";
		widgetLocationSelectTitle.innerText = "Choose a location";

		for (let i = 0; i < widgetLanguageLabel.length; i++) {
			let label = widgetLanguageLabel[i];

			if (!label.innerText.includes('語言')) continue;

			label.innerText = 'Language';
		}

		for (let i = 0; i < widgetLanguageOptions.length; i++) {
			let option = widgetLanguageOptions[i];

			if (option.innerText.includes('中文')) {
				option.innerText = 'Chinese';
			}

			if (option.innerText.includes('英文')) {
				option.innerText = 'English';
			}
		}


		widgetAddToCartBtn.innerText = widgetAddToCartBtn.innerText.replace('加進購物車', "Add to cart");
	})
})

function updateSlotText(widgetPopup) {
	setTimeout(function() {
		let slots = widgetPopup.contentWindow.document.querySelectorAll('.time-slot-radio-buttons span');

		slots.forEach(slot => {
			slot.innerText = slot.innerText.replace('個名額', 'space(s) left').replace('滿額', 'Full class');
		})		
	}, 0)
}